
// Answer 'FrameHeightRequest' messages from the parent page to resize
// the iframe such that it fits the content displayed on this page
// Counterpart: assets/scripts/embed.js
window.addEventListener('message', evt => {
  // eslint-disable-next-line no-prototype-builtins
  if (evt.data.hasOwnProperty('frameHeight') &&
      // eslint-disable-next-line no-prototype-builtins
      evt.data.hasOwnProperty('frameIndex')) {

    // Calculate height necessary to fit whole page inside a frame
    const frameHeight = Math.max(
      document.body.scrollHeight,
      document.body.offsetHeight
    );

    // Send frame height back to the parent page
    evt.source.postMessage({
      frameHeight,
      frameIndex: evt.data.frameIndex
    }, '*');
  }
});
